import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/registry/_layout/')({
  component: () => null, // Content rendered by _layout parent
});
